module.exports = __webpack_public_path__ + "public/SiteIcons/completedIcon.svg?2dd9d927";